import {
  Line
} from "vue-chartjs";
import messages from "@/languages/index"
import store from "../../store"
let language = localStorage.getItem('language') || store.state.language || "pt"

//? Tipos de dados de configuração de cada "dataset" do "chartLineData"
//* {
//?   OPCIONAL - utilizado caso esteja utilizando a prop "dataItems"
//*   id: "Some label",
//?   OBRIGATÓRIO caso não utilize "labelTranslate" - utilizado na legenda
//?   e nos tooltips
//*   label: "Some label",
//?   OBRIGATÓRIO caso não utilize "label" - utilizado na legenda
//?   e nos tooltips ("affiliate" é buscado no arquivo de tradução)
//*   labelTranslate: "affiliate",
//?   OPCIONAL - utilizado caso queira algum background da linha para baixo
//*   backgroundColor: "rgba(0,0,0,0)",
//?   OPCIONAL - utilizado caso queira algum background gradient linear
//?   da linha para baixo
//*   backgroundColorGradient: ["rgb(71, 126, 50)", "rgba(71, 126, 50, 0)"],
//?   OBRIGATÓRIO - utilizado para popular os dados do gráfico (cada
//?   item do array equivale a cada label da prop "labels")
//*   data: [],
//?   OPCIONAL - utilizado caso queira adicionar alguma borda na linha do
//?   gráfico e no retângulo da legenda
//*   borderColor: "white",
//?   OPCIONAL - utilizado caso queira adicionar algum background no ponto
//*   pointBackgroundColor: "white",
//?   OPCIONAL - utilizado caso queira adicionar algum background no ponto de
//?   acordo com o eixo X (acima ou abaixo de 0)
//*   pointBackgroundColorVariant: ["rgb(71, 126, 50)", "#A11919"],
//?   OPCIONAL - utilizado caso queira mudar a espessura da linha do gráfico
//?   e no retângulo legenda
//*   borderWidth: 2,
//?   OPCIONAL - utilizado caso queira adicionar alguma cor na borda do ponto
//*   pointBorderColor: "white",
//?   OPCIONAL - utilizado caso queira adicionar alguma cor na borda do ponto de
//?   acordo com o eixo X (acima ou abaixo de 0)
//*   pointBorderColorVariant: ["rgb(71, 126, 50)", "#A11919"],
//?   OPCIONAL - utilizado caso queira adicionar alguma cor na linha do gráfico
//?   de acordo com o eixo X (acima ou abaixo de 0)
//*   negativeLinesColor: ["rgb(86,188,77)", "rgb(229,66,66)"],
//* }

export default {
  name: "LineChart",
  extends: Line,
  props: [
    //? Dados de configuração (chartLinedata.datasets)
    "data",
    //? Dados dos dados de cada dataset caso queira utilizar dessa forma
    //? (chartLinedata.datasets[n].data)
    "dataItems",
    //? Dados dos textos Verticais (abaixo do gráfico)
    "labels",
    //? Opções de configuração (options) - options: {
    //?                                      width: "320px",
    //?                                      height: "300px",
    //?                                    },
    "modifyOptions",
  ],
  data: () => ({
    chartLinedata: {
      labels: [],
      datasets: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          // Tira a curvatura da linha do gráfico
          tension: 0,
        },
      },
      title: {
        display: false,
        position: "top",
        text: "Some title"
      },
      tooltips: {
        mode: "index",
        intersect: false,
      },
      hover: {
        mode: "nearest",
        intersect: true,
      },
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: false,
            labelString: "Horizontal label"
          },
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: false,
            labelString: "Vertical label"
          }
        }]
      }
    },
    modifyLineColor: {
      beforeRender: function (x) {
        var c = x.chart
        var dataset = x.data.datasets[0];
        var allDatasets = x.data.datasets;
        var yScale = x.scales["y-axis-0"];
        var yPos = yScale.getPixelForValue(0);

        allDatasets.forEach((dataSet, index) => {
          // Cores das linhas para GGR
          if (dataSet.negativeLinesColor) {
            var [firstColor, secondColor] = dataSet.negativeLinesColor;
            var gradientFill = c.ctx.createLinearGradient(0, 0, 0, c.height);

            gradientFill.addColorStop(0, firstColor);
            gradientFill.addColorStop(yPos / c.height - 0.001, firstColor);
            gradientFill.addColorStop(yPos / c.height + 0.001, secondColor);
            gradientFill.addColorStop(1, secondColor);
          }

          var model = x.data.datasets[index]
            ._meta[Object.keys(dataset._meta)[0]].dataset._model;

          // model.backgroundColor = gradientFill;
          model.borderColor = gradientFill;
        });
      }
    },
  }),
  mounted() {
    if (this.modifyOptions) {
      this.formatChartLineOptions();
    }

    this.formatChartLineData();
  },
  watch: {
    data() {
      this.formatChartLineData();
      this.renderChart(this.chartLinedata, this.options);
    },
    dataItems() {
      this.formatChartLineData();
      this.renderChart(this.chartLinedata, this.options);
    },
    labels(val) {
      this.chartLinedata.labels = val;
      this.renderChart(this.chartLinedata, this.options);
    },
    modifyOptions() {
      this.formatChartLineOptions();
      this.renderChart(this.chartLinedata, this.options);
    },
  },
  methods: {
    formatChartLineData() {
      //! Pode ser mandado os dados de "data" tanto junto com as configs quando
      //! de forma separada caso utilize dados separados (normalmente utilizado
      //! quando é usado mais de uma vez o componente na mesma view) é importante
      //! a prop "dataItems" seja um objeto onde a chave é o "id" de cada item de
      //! "data"
      this.chartLinedata.datasets = JSON.parse(JSON.stringify(this.data))
        .map((data) => {
          //* Caso tenha o membro "negativeLinesColor" adiciona o plugin de
          //* modificação da linha de acordo com o eixo X
          if (data.negativeLinesColor) {
            this.addPlugin(this.modifyLineColor);
          }

          return {
            ...data,
            label: data.labelTranslate ?
              messages[language][data.labelTranslate] :
              data.label,
            backgroundColor: data.backgroundColorGradient ?
              this.formatBackgroundGradient(
                data.backgroundColorGradient[0],
                data.backgroundColorGradient[1]
              ) :
              data.backgroundColor ?
                data.backgroundColor :
                "rgba(0,0,0,0)",
            data: this.dataItems ? this.dataItems[data.id] : data.data,
            ...(data.pointBackgroundColorVariant ? {
              pointBackgroundColor: this.dataItems[data.id]
                .map((value) => value >= 0 ?
                  data.pointBackgroundColorVariant[0] :
                  data.pointBackgroundColorVariant[1]
                ),
              } : {}
            ),
            ...(data.pointBorderColorVariant ? {
              pointBorderColor: this.dataItems[data.id]
                .map((value) => value >= 0 ?
                  data.pointBorderColorVariant[0] :
                  data.pointBorderColorVariant[1]
                )
              } : {}
            ),
          };
        });
    },
    formatBackgroundGradient(color1, color2) {
      return (ctx) => {
        const canvas = ctx.chart.ctx;
        const gradient = canvas.createLinearGradient(0,0,0,400);
        gradient.addColorStop(0, color1);
        gradient.addColorStop(1, color2);

        return gradient;
      };
    },
    formatChartLineOptions() {
      //? Estrutura da prop "modifyOptions"
      //* options: {
      //*   width: "320px",
      //*   height: "300px",
      //*   lineTension: 0 || 1 || n || "softTension",
      //*   title: {
      //*     display: true,
      //*     position: 'top',
      //*     text: 'Some title'
      //*   }
      //*   horizontalLabel: "Horizontal label",
      //*   verticalLabel: "Vertical label",
      //*   anyStyle: {
      //*     name: "margin-right",
      //*     value: "10px",
      //*   },
      //* },

      //? "document.getElementById("line-chart").style"
      //? Com o código acima é possível alterar qualquer estilo do canvas
      //? Dê um console.log para vizualizar como o nome do estilo é configurado
      const {
        width,
        height,
        lineTension,
        title,
        horizontalLabel,
        verticalLabel,
        anyStyle,
      } = this.modifyOptions;

      if (width) {
        this.options.responsive = false;
        const listCanvas = document.getElementsByTagName("canvas");
        for (var i = 0; i < listCanvas.length; i++) {
          listCanvas[i].style.width = width;
        }
      }

      if (height) {
        const listCanvas = document.getElementsByTagName("canvas");
        for (var j = 0; j < listCanvas.length; j++) {
          listCanvas[j].style.height = height;
        }
      }

      if (lineTension) {
        // tension: 0              --> linha reta
        // tension: 1              --> curva grande na linha
        // tension: "softTension"  --> sem tension (curva suave na linha)
        this.options.elements.line = {
          ...this.options.elements.line,
          ...(lineTension == "softTension" ? {} : { tension: lineTension }),
        };
      }

      if (title) {
        this.options.title = {
          ...this.options.title,
          display: true,
          ...title, // { position: "top", text: "Some text" }
        };
      }

      if (horizontalLabel || verticalLabel) {
        if (horizontalLabel) {
          this.options.scales.xAxes[0].scaleLabel = {
            display: true,
            labelString: horizontalLabel,
          };
        }
        if (verticalLabel) {
          this.options.scales.yAxes[0].scaleLabel = {
            display: true,
            labelString: verticalLabel,
          };
        }
      }

      if (anyStyle) {
        document.getElementById("line-chart")
          .style[anyStyle.name] = anyStyle.value;
      }
    },
  },
};